import {Component, Inject, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {Store} from '@ngrx/store';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {take, takeUntil} from 'rxjs/operators';
import {IconViewModel, IconViewResponse} from '@features/file-manager/models/file-manager.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FileSelectorModel} from '@features/file-manager/models/file-selector.model';
import {FileOrFolderSelectorService} from '@shared/services/file-or-folder-selector.service';
import {TabModel} from '@shared/models/platform-tool-models';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {FileMetadata} from '@shared/models/file-model';
import {Subscription} from 'rxjs';
import {Subject} from 'rxjs';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {UploadFileIndex} from '@features/file-manager/file-manager-config';
import {FileManagerService} from '@features/file-manager/services/file-manager.service';
import {
  UploadFileDialogComponent
} from '@features/file-manager/component/dialog-components/upload-file-dialog/upload-file-dialog.component';
import {Api} from '@shared/constants/common-field.constants';

@Component({
    standalone: false,
    selector: 'app-orbitax-file-selector-dialog',
  templateUrl: './orbitax-file-selector-dialog.component.html',
  styleUrls: ['./orbitax-file-selector-dialog.component.scss']
})

export class OrbitaxFileSelectorDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  selectedItems: IconViewModel[] = [];
  breadcrumbList: BreadcrumbModel[] = [];
  parentId: string;
  isClientDrive: boolean;
  skipBreadcrumbItem: boolean;
  returnType: string;
  invalidateSubject = new InvalidateSubject();
  fileExtensionTypes: string[];
  hideFiles: boolean;
  moveToParentId: string;
  actionType: string;
  loaded = false;
  iconViewModels: IconViewModel[];
  foldersSelectable = false;
  selectOnlyCurrentDirectoryFiles = false;
  selectedTab = new TabModel();
  driveId: string;
  files: any[] = [];
  hasDnDEnabled = false;
  gridVisible = true;
  showActions: boolean;
  private uploadSubscription$: Subscription[] = [];
  private unsubscribe$ = new Subject<void>();
  private createNewFolderCommand: PlatformCommand;
  private fileSelectorModel: FileSelectorModel;
  private isMultiSelection = true;
  fileIconViewQueryName: string;
  viewType = 'IconView';
  dynamicItemService = 'FileSelectorDirectoryEntryDynamicItemService';
  sourceType = 'FileSelectorPopUpClientDirectoryEntry';
  selectedIconViewModels: IconViewModel[] = [];
  locked = false;
  deleteOption = false;
  overwrite = false;
  constructor(@Inject(MAT_DIALOG_DATA) public info: DialogModel,
              private platformQueryService: PlatformQueryService,
              private commandService: CommandService,
              protected store: Store<IQueryState>,
              private snackBarService: SnackBarService,
              private fileStoreCommonService: FileStoreCommonService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileOrFolderSelectorService: FileOrFolderSelectorService,
              protected dialog: MatDialog,
              private fileManagerService: FileManagerService) {
  }


  ngOnInit(): void {
    const fileSelectorModel = this.data.input.fileSelectorModel as FileSelectorModel;

    if (fileSelectorModel) {
      this.parentId = fileSelectorModel.parentId;
      this.isClientDrive = fileSelectorModel.isClientDrive;
      this.fileExtensionTypes = fileSelectorModel.fileExtensionTypes;
      this.hideFiles = fileSelectorModel.hideFiles;
      this.selectedItems = fileSelectorModel.iconViewModels;
      this.skipBreadcrumbItem = fileSelectorModel.skipBreadcrumbItem ?? true;
      this.returnType = fileSelectorModel.returnType;
      this.foldersSelectable = fileSelectorModel.foldersSelectable;
      this.selectOnlyCurrentDirectoryFiles = fileSelectorModel.selectOnlyCurrentDirectoryFiles ?? false;
      if(fileSelectorModel.iconViewQueryName){
        this.fileIconViewQueryName = fileSelectorModel.iconViewQueryName;
      }
      this.locked = fileSelectorModel.locked ?? false;
      this.deleteOption = fileSelectorModel.deleteOption ?? false;
      this.overwrite = fileSelectorModel.overwrite ?? false;
    }
    if (this.viewType === 'ListView') {
      this.updateDataForListView();
    }
    this.data.isDisabledOkButton = !this.selectedItems.length;
    this.getBreadcrumbData();
  }

  getBreadcrumbData() {
    this.breadcrumbList = [];
    const query = new PlatformQuery();
    query.name = 'BreadcrumbQuery';
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues['ParentId'] = this.parentId;
    query.fieldValues['IsClientDrive'] = this.isClientDrive;
    query.fieldValues['SkipBreadcrumbItem'] = this.skipBreadcrumbItem;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.breadcrumbList = response.fieldValues['BreadcrumbList'];
      this.showActions = response.fieldValues['ShowActions'] as boolean ?? true;
      if (response.fieldValues['CreateNewFolderCommand']) {
        this.createNewFolderCommand = response.fieldValues['CreateNewFolderCommand'];
      }
    });
  }

  updateDataForListView() {
    this.dynamicItemService = this.parentId === 'Team Drives' ? 'FileSelectorPopUpSharedDrivesDynamicItemService' : 'FileSelectorDirectoryEntryDynamicItemService';
    this.sourceType = this.parentId === 'Team Drives' ? 'FileSelectorPopUpSharedDrives' : 'FileSelectorPopUpClientDirectoryEntry';
    this.getDriveId();
  }

  navigateFromBreadCrumb(item: any) {
    if (this.locked) { return; }
    this.gridVisible = false;
    this.parentId = item.id;
    if (item && item.id === 'drive') {
      this.parentId = 'Team Drives';
    } else {
      this.parentId = item.id;
    }
    if (this.viewType === 'ListView') {
      this.updateDataForListView();
    }
    this.selectedTab.tabData.ParentId = this.parentId;
    this.fileOrFolderSelectorService.setParentId(this.parentId);
    if ( this.viewType !== 'ListView') {
      this.invalidateSubject.invalidate(this.parentId);
    }
    this.getBreadcrumbData();
    this.toggleDnd(this.parentId);
    setTimeout(() => {
      this.gridVisible = true;
    },10);
  }

  onItemsSelectedFromGrid($event: any) {
    if ($event.item.isChecked === false) {
      this.selectedIconViewModels = this.selectedIconViewModels.filter( (x: any) => $event.item.cells['IconViewModel'].value.itemId !== x.itemId);
    } else {
      this.selectedIconViewModels.push($event.item.cells['IconViewModel'].value as IconViewModel);
    }
    this.onSelectedItems(this.selectedIconViewModels);
  }

  onSelectedItems(itemList: IconViewModel[]) {
    const selectedItems = itemList;
    if (!this.locked && selectedItems.length === 1 && ((selectedItems[0].isSelected === false) || selectedItems[0].type === 'SharedDrive')) {
      this.parentId = selectedItems[0].itemId;
      this.getBreadcrumbData();
      this.invalidateSubject.invalidate(this.parentId);
      if (this.foldersSelectable) {
        this.selectedItems = itemList.filter(o => o.type === 'Folder');
      }
      if (this.selectOnlyCurrentDirectoryFiles) {
        this.selectedItems = [];
      }
    } else if(!this.data.input.fileSelectorModel.isMultiSelection && selectedItems.length > 1 && this.foldersSelectable) {
      const previousSelectedItem = selectedItems[0];
      this.selectedItems = itemList.filter(o => o.itemId !== previousSelectedItem.itemId && o.type === 'Folder');
      if(this.selectedItems && this.selectedItems.length > 1){
        this.selectedItems = this.selectedItems.slice(-1);
      }

    } else {
      this.selectedItems = itemList;
    }
    this.data.isDisabledOkButton = !this.selectedItems.length;
  }

  onOkClicked() {
    if (this.actionType === 'Move') {
      this.data.input.MoveParentToId = this.moveToParentId;
      return true;
    }
    if (this.selectedItems && this.selectedItems.length > 0) {
      if (this.returnType === 'RelativePath') {
        this.data.input.selectedItems = this.selectedItems.map(item => ({
          'name': item.name,
          'relativePath': item.relativePath,
          'stringifyRelativePath': item.stringifyRelativePath,
          'type': item.type,
          'itemId': item.itemId
        }));
      } else {
        this.data.input.selectedItems = this.selectedItems;
      }
      this.data.input.parentId = this.parentId;
      return true;
    }
    return false;
  }

  onIconViewItemClicked({parentId, driveId}: { parentId: string, driveId: string }) {
    this.moveToParentId = parentId;
    this.parentId = parentId;
    this.driveId = driveId;
    this.toggleDnd(this.parentId);
    this.fileOrFolderSelectorService.setParentId(this.parentId);
  }

  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      item.cancelled = false;
      item.formatedSize = this.fileStoreCommonService.formatBytes(item.size);
      this.files.push(item);
    }
    this.uploadFiles(0);
  }

  cancelUpload(index: number, errorMessage?: string) {
    if (this.uploadSubscription$[index]) {
      this.uploadSubscription$[index].unsubscribe();
    }
    this.files[index].cancelled = true;
    this.files[index].progress = 0;
    if (errorMessage) {
      this.files[index].errorMessage = errorMessage;
    }
    this.uploadFiles(index + 1);
  }

  retryUpload(index: number) {
    this.files[index].cancelled = false;
    this.files[index].progress = 0;
    this.uploadFiles(index, () =>
      this.invalidateSubject.invalidate(this.parentId));
  }

  onButtonClicked(actionName: string) {
    switch (actionName) {
      case 'create-folder':
        this.fuseSplashScreenService.show();
        this.createNewFolderCommand.fieldValues['DriveId'] = this.driveId;
        this.createNewFolderCommand.fieldValues['ParentId'] = this.parentId;
        this.commandService.executePlatformCommand(this.createNewFolderCommand).subscribe(res => {
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate(JSON.stringify(res.fieldValues));
          this.fuseSplashScreenService.hide();
        });
        break;
      case 'upload-file':
        const command = new PlatformCommand('UploadFileCommand', Api.FileStoreApi);
        command.fieldValues['DriveId'] = this.driveId;
        command.fieldValues['ParentId'] = this.parentId;
        this.uploadFile(command);
        break;
      case 'delete-file':
        this.deleteSelectedItems();
        break;
    }
  }

  deleteSelectedItems() {
    if (!this.selectedItems || this.selectedItems.length === 0) { return; }
    this.fuseSplashScreenService.show();
    const deleteCommand = new PlatformCommand('DeleteFileOrFolderCommand', Api.FileStoreApi);
    deleteCommand.fieldValues['DirectoryEntryIds'] = this.selectedItems.map(item => item.itemId);
    deleteCommand.fieldValues['DriveId'] = this.driveId;
    deleteCommand.fieldValues['IsClientDrive'] = this.isClientDrive;
    this.commandService.executePlatformCommand(deleteCommand).pipe(take(1)).subscribe(res => {
      if (res.fieldValues['SnackBarMessage']) {
        const duration = res.fieldValues['SnackBarMessage'].length * 80;
        this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
      }
      this.selectedItems = [];
      this.data.isDisabledOkButton = true;
      this.invalidateSubject.invalidateAlways(this.parentId);
      this.fuseSplashScreenService.hide();
    });
  }

  directUpload(driveId: string, parentId: string, formData: FormData) {
    const fileMetaData = new FileMetadata();
    fileMetaData.fileName = formData.get('fileName').toString();
    fileMetaData.driveId = driveId;
    fileMetaData.parentId = parentId;
    fileMetaData.publishEvent = false;
    fileMetaData.overwrite = this.overwrite;
    formData.set('overwrite', String(fileMetaData.overwrite));
    const file = formData.get('file') as File;
    this.fuseSplashScreenService.show();
    this.fileManagerService.directUploadInS3(fileMetaData, formData, UploadFileIndex.Client).pipe(take(1)).subscribe(res => {
      console.log('Direct Upload', res);
      this.fuseSplashScreenService.hide();
      const command = res['directUploadSuccessCommand'];
      command.fieldValues['FileSize'] = file.size;
      this.commandService.executePlatformCommand(command).subscribe((val) => {
        console.log(val);
        this.invalidateSubject.invalidateAlways(this.parentId);
        this.fuseSplashScreenService.hide();
      });
    }, (error: string) => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError(error);
      console.log('Error', error);
    });
  }

  private toggleDnd(parentId: string) {
    this.hasDnDEnabled = this.parentId !== '' && this.parentId !== 'Team Drives';
  }

  private uploadFiles(index: number, callback?: () => void) {
    if (index === this.files.length) {
      if (this.files.length > 0) {
        this.invalidateSubject.invalidate();
      }
      return;
    } else {
      const file = this.files[index];
      if (file && file.progress < 100 && !file.cancelled) {
        console.log('[Uploading File] of Index: ', index, file);
        this.uploadSubscription$[index] = this.fileStoreCommonService
          .uploadFile(this.getFileData(file))
          .subscribe((res: HttpEvent<Object>) => {
            const event = res['event'] as HttpEvent<Object>;
            switch (event.type) {
              case HttpEventType.Sent:
                console.log('Request has been made!');
                break;
              case HttpEventType.ResponseHeader:
                console.log('Response header has been received!');
                break;
              case HttpEventType.UploadProgress:
                this.files[index].progress = Math.round(
                  (event.loaded / event.total) * 90
                );
                console.log(`Uploaded! ${this.files[index].progress}%`);
                break;
              case HttpEventType.Response:
                console.log('File uploaded successfully!', event.body);
                this.files[index].progress = 100;
                this.files[index].itemId = event.body;
                const command = res['directUploadSuccessCommand'];
                command.fieldValues['FileSize'] = file.size;
                command.fieldValues['HasSnackBarMessage'] = this.overwrite;
                this.commandService.executePlatformCommand(command)
                  .pipe(
                    take(1),
                    takeUntil(this.unsubscribe$))
                  .subscribe(payload => {
                    if (payload.fieldValues) {
                      this.files[index].itemId = payload.fieldValues['ItemId'];
                      this.invalidateSubject.invalidate(this.parentId);
                    }
                  });
                if (callback) {
                  callback();
                } else {
                  setTimeout(() => {
                    this.uploadFiles(index + 1);
                  }, 200);
                }
            }
          }, error => {
            console.log('[Upload File] Error Message', error);
            this.cancelUpload(index, error);
          });
      } else {
        this.uploadFiles(index + 1);
      }
    }
  }

  private getFileData(file: any): { formData: FormData, fileMetaData: FileMetadata } {
    const fileName = file ? file.name.slice(0, file.name.lastIndexOf('.')) : null;
    const fileExtension = file ? file.name.slice(file.name.lastIndexOf('.'), file.name.length) : null;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName + fileExtension);
    formData.append('parentId', this.parentId);
    formData.append('driveId', this.driveId);
    formData.append('overwrite', String(this.overwrite));

    const fileMetaData = new FileMetadata();
    fileMetaData.fileName = formData.get('fileName').toString();
    fileMetaData.driveId = this.driveId;
    fileMetaData.parentId = this.parentId;
    fileMetaData.publishEvent = false;
    fileMetaData.overwrite = this.overwrite;
    return {formData, fileMetaData};
  }

  private uploadFile(command: PlatformCommand): boolean {
    let driveId = command.fieldValues['DriveId'];
    const parentId = command.fieldValues['ParentId'];
    const relativePath = command.fieldValues['RelativePath'];
    if (relativePath) {
      driveId = relativePath;
    }
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        parentId: parentId,
        driveId: driveId,
      },
      disableClose: true
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((result: FormData) => {
      console.log('FormData', result);
      if (result) {
        this.fuseSplashScreenService.show();
        this.directUpload(driveId, parentId, result);
      }
    });
    return true;
  }

  onIconViewDataFetched(event: IconViewResponse) {
    if ( this.foldersSelectable && event.parentIconViewModel && (!this.selectedItems || this.selectedItems.length === 0) ) {
      this.selectedItems = [event.parentIconViewModel];
      this.data.isDisabledOkButton = !this.selectedItems.length;
    }
  }

  onCellEditorClicked($event: any) {
    if (($event.item.cells['IsFolder'] && $event.item.cells['IsFolder'].value === true) ||
      ($event.item.cells['IsDrive'] && $event.item.cells['IsDrive'].value === true)) {
      this.navigateFromBreadCrumb($event.item);
    } else {
      this.onItemsSelectedFromGrid($event);
    }
    this.fileOrFolderSelectorService.setParentId($event.item.id);
  }

  getDriveId() {
    this.breadcrumbList = [];
    const query = new PlatformQuery();
    query.name = 'FileSelectorPopupDriveQuery';
    query.api = Api.FileStoreApi;
    query.fieldValues['ParentId'] = this.parentId;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.driveId = response.fieldValues['DriveId'];
    });
  }

  toggleViewType(view: string) {
    this.viewType = view;
    if (this.viewType !== 'ListView') {
      this.invalidateSubject.invalidate(this.parentId);
    } else {
      this.getBreadcrumbData();
      this.updateListViewParameters();
      this.updateDataForListView();
    }
  }
  updateListViewParameters() {
      if (this.hideFiles === undefined || this.hideFiles === null ) {
        this.hideFiles = false;
      }
      if ( this.fileExtensionTypes === undefined || this.fileExtensionTypes === null) {
        this.fileExtensionTypes = [];
      }
  }
}

